import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type UserFailReportState = {
  errorCode?: string;
  reportDate?: string;
};

const initialState: UserFailReportState = {};

const userFailReportSlice = createSlice({
  name: 'userFailReport',
  initialState,
  reducers: {
    setUserFailReport(
      state,
      action: PayloadAction<UserFailReportState>,
    ): UserFailReportState {
      return { ...state, ...action.payload };
    },
    clearUserFailReport(): UserFailReportState {
      return {};
    },
  },
});

export const { setUserFailReport, clearUserFailReport } =
  userFailReportSlice.actions;
export default userFailReportSlice.reducer;
